<template>
  <div class="recruitDetails">
    <div class="header">
      <div class="inner">
        <i class="el-icon-s-home" @click="goIndex"></i>
        <span @click="gotoList">返回职位列表</span>
      </div>
    </div>
    <div class="positionDetails">
      <el-row class="warp">
        <el-col :span="6" class="right">
          <div class="inner">
            <div class="title">
              <span class="new">最新职位</span>
              <span class="more" @click="gotoList">更多</span>
            </div>
            
            <div class="common" v-for="(item, index) in recentJobList" :key="index" @click="gotoReplace(item.id)">{{item.jobName}}</div>

          </div>
        </el-col>
        <el-col :lg="18" :md="18" :xs="24" class="left">
          <div class="title">
            <div class="time">
              <span>发布时间：{{jobContent.time.split(" ")[0]}}</span>
              <div @mouseenter="share"  @mouseleave="share">
                <span>分享 <i class="el-icon-arrow-down"></i></span>
                <transition name="el-fade-in-linear" class="shareBox">
                  <div v-show="shareFlag" class="transition-box">
                    <p>扫码分享职位</p>
                    <div class="shareImg">
                      <div style="width: 100%;height: 100%;" :id="id" ref="qrcode"></div>
                      <span class="copySucMsg" v-show="copySucMsgFlag"> <i class="el-icon-check"></i> 复制成功</span>
                    </div>
                    <p>或使用链接分享</p>
                    <div class="copyBox">
                      <div>
                        <el-input size="medium" disabled :placeholder="urlPlaceholder"></el-input>
                      </div>
                      <div @click="handleCopy" v-clipboard:copy="msgExample">复制</div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div class="name">{{jobContent.category}}</div>
            <div class="type">{{jobContent.subCategory}}</div>
            <!-- <div class="place">昆山 丘钛</div>
            <button @click="goApply">申请职位</button> -->
          </div>
          <div class="description">
            <div class="part2">
              <div class="title">
                职位信息
                <span></span>
              </div>
              <div class="content2">
                <el-row>
                  <el-col :span="8" class="item">
                    <p>招聘人数</p>
                    <p>{{jobContent.number}}人</p>
                  </el-col>
                  <el-col :span="8" class="item">
                    <p>学历要求</p>
                    <p>{{jobContent.education}}</p>
                  </el-col>
                  <el-col :span="8" class="item">
                    <p>工作城市</p>
                    <p>{{jobContent.baseCity}}</p>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="part1">
              <div class="title">
                岗位职责
                <span></span>
              </div>
              <div class="content1" innerHtml="form_str">
                <div  v-html="jobContent.responsibilities">
                
                </div>
              </div>
              <div class="content2" >
                <p>任职要求：</p>
                <div  v-html="jobContent.requirements">
                
                </div>
              </div>
            </div>
          </div>
          <div class="apply">
            <span @click="goApply">申请职位</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button v-waves class="fixedButton" @click="goApply">简历投递</el-button>
    <Footer></Footer>
  </div>
</template>
  
  <script>
import Headers from "@/components/Headers.vue";
import Footer from "@/components/Footer.vue";
import waves from "@/directive/waves";
import QRCode from 'qrcodejs2'

export default {
  name: "recruitDetails",
  components: { Headers , Footer,QRCode},
  directives: {
    waves,
  },
  props: {
    id: {
      type: String,
      required: true
    },
    text: {  // 后端返回的二维码地址
      type: String,
      default: 'http://jindo.dev.naver.com/collie'
    },
    width: {
      type: String,
      default: '128'
    },
    height: {
      type: String,
      default: '128'
    },
    colorDark: {
      type: String,
      default: '#000000'
    },
    colorLight: {
      type: String,
      default: '#ffffff'
    }
  },
  data() {
    return {
      jobName:"",
      jobId:0,
      urlPlaceholder:"http://openapi.qtechglobal.com:8003/index",
      msgExample: "",
      jobContent:{
        number:0, //招聘人数
        education: '', //学历
        baseCity:'', //工作城市
        category:'', //主分类
        subCategory:'', // 子分类
        responsibilities:'', //岗位职责
        requirements:'', // 任职要求
        time:""
      },
      recentJobList:[],
      copySucMsgFlag:false,
      shareFlag:false,
      vshareConfig: {
          shareList: [
            // 此处放分享列表（ID）
            'more',
            'qzone',
            'tsina',
            'tqq',
            'renren',
            'weixin'
          ],
          common : {
            //此处放置通用设置
          },
          share : [{
            //此处放置分享按钮设置
            }
          ],
          slide : [
            //此处放置浮窗分享设置
          ],
          image : [
            //此处放置图片分享设置
          ],
          selectShare : [
            //此处放置划词分享设置
          ]
        }
    };
  },
  created(){
    this.jobId = this.$route.query.id;
    this.msgExample = "http://openapi.qtechglobal.com:8003/recruitDetails?id=" + this.jobId;
    this.getDetail(this.jobId);
    this.getRecentJobList();
  },
  mounted(){
    this.createQrcode();
    // windows.location.reload();
    this.$nextTick(()=>{
      this.vshareConfig = {
          shareList: [
            // 此处放分享列表（ID）
            'more',
            'qzone',
            'tsina',
            'tqq',
            'renren',
            'weixin'
          ],
          common : {
            //此处放置通用设置
          },
          share : [{
            //此处放置分享按钮设置
            }
          ],
          slide : [
            //此处放置浮窗分享设置
          ],
          image : [
            //此处放置图片分享设置
          ],
          selectShare : [
            //此处放置划词分享设置
          ]
        }
    });
  },
  watch: {
    $route() {
      this.jobId = this.$route.query.id;
      this.getDetail(this.jobId);
    }
  },
  methods: {
    copyText(){
      return "http://openapi.qtechglobal.com:8003/recruitDetails?id=" + this.jobId;
    },
    getRecentJobList(){
      let params = {
        current:1,
        pageSize:5
      };
      this.axios({
        url: "/apis/job/list",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          this.recentJobList = res.rows;
        } else {
          this.recentJobList = [];
        }
      });
    },
    getDetail(id){
      this.axios({
        url: "/apis/job/info/" + id,
        method: "get",
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          this.jobName = data.jobName;
          this.jobContent = {
            number: data.requireNum, //招聘人数
            education: data.educationRequire, //学历
            baseCity: data.workCity, //工作城市
            category: data.jobType, //主分类
            subCategory: data.jobName, // 子分类
            responsibilities: data.jobDescribe, //岗位职责
            requirements: data.jobRequire, // 任职要求
            time: data.createTime
          }
        } else {
          this.jobContent = {};
        }
      });
    },
    createQrcode() {
      if(this.qrcode) {  // 有新的二维码地址了，先把之前的清除掉
        this.$refs['qrcode'].innerHTML = ''
      }
      this.qrcode = new QRCode(this.$refs['qrcode'], {
        text: "http://openapi.qtechglobal.com:8003/recruitDetails?id=" + this.jobId, //页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: this.width, // 二维码宽度 （不支持100%）
        height: this.height, // 二维码高度 （不支持100%）
        colorDark: this.colorDark,
        colorLight: this.colorLight,
        correctLevel: QRCode.CorrectLevel.H,
      })
    },
    handleCopy(){
      this.copySucMsgFlag = true;
      let _this = this;
      setTimeout(function(){
        _this.copySucMsgFlag = false;
      },2000)
    },
    share(){
      this.shareFlag = !this.shareFlag;
      this.copySucMsgFlag = false;
    },
    goApply() {
      this.$confirm('请确认好自己的意向岗位再投递，并请提前准备好简历电子档便于提交（若为内部推荐，请确认好内荐人工号）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push('/applyInfo?id='+ this.jobId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消申请'
        });          
      });
    },
    gotoReplace(id) {
      this.$router.push('/recruitDetails?id='+id);
    },
    goIndex(){
      this.$router.push({
        name: "index",
      });
    },
    goIndex(){
      this.$router.push("/index");
    },
    gotoList(){
      this.$router.push({
        name: "recruitList",
      });
    },
    gotoDetails() {
      this.$router.push({
        name: "recruitDetails",
        params: {
          id: 10,
        },
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.recruitDetails {
  background-color: #f4f4f6;
  @media (max-width: 1200px) {
    background-color: #fff;
  }
  .header {
    height: 80px;
    line-height: 80px;
    background-color: #0099FF;
    @media (max-width: 1200px) {
      height: 50px;
      line-height: 50px;
    }
    .inner {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: space-between;
      min-width: 968px;
      max-width: 1200px;
      margin: 0 auto;
      color: #fff;
      @media (max-width: 1200px) {
        min-width: 100%;
        max-width: 100%;
        padding: 0 0 0 15px;
      }
      span {
        display: inline-block;
        &:first-of-type {
          cursor: pointer;
        }
        @media (max-width: 1200px) {
          padding-right: 15px;
        }
      }
      i{
        cursor: pointer;
        line-height: 80px;
        height: 80px;
        font-size: 36px;
        @media (max-width: 1200px) {
          line-height: 50px;
          height: 50px;
          font-size: 30px;
        }
      }
    }
  }
  .positionDetails {
    text-align: left;
    padding: 30px 0 80px;
    height: 100%;
    @media (max-width: 1200px) {
      padding: 0 0 80px;
    }
    .warp {
      width: 1200px;
      margin: 0 auto;
      @media (max-width: 1200px) {
        width: 100%;
      }
      .left {
        background-color: #fff;
        > .title {
          margin-bottom: 16px;
          padding-bottom: 16px;
          font-size: 14px;
          padding: 20px 20px 0 20px;
          position: relative;
          .time {
            color: #989cb2;
            font-size: 12px;
            position: relative;
            @media (max-width: 1200px) {
              display: none;
            }
            >div{
              float: right;
              color: #9a9fac;
              font-size: 12px;
              cursor: pointer;
              >span{
                padding-right: 10px;
              }
            }
            .transition-box{     
              padding: 0 20px 20px;
              box-shadow: 0 0 10px #aeaeae;
              width: 220px;
              background-color: #fff;
              position: absolute;
              z-index: 10000;
              right: 80px;
              top: 140px;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              color: #000;
              border-radius: 10px;
              p{
                font-size: 14px;
              }
             
              .shareImg{
                position: relative;
                img{
                  width: 100%;
                }                
                .copySucMsg{
                  width: 70%;
                  text-align: center;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%,-50%);
                  background-color: rgba(0,0,0,.8);
                  border-radius: 6px;
                  color: #fff;
                  padding: 10px;
                }
              }
              .copyBox{
                display: flex;
                flex-direction: row;
                >div{
                  display:inline-block;
                  vertical-align: middle;
                  &:nth-child(1){
                    width: 70%;

                  }
                  &:nth-child(2){
                    cursor: pointer;
                    width: 30%;
                    text-align: center;
                    line-height: 40px;
                    font-size: 14px;
                    color: #0c8cf6;
                  }
                }
                .el-input__inner{
                  padding: 0 3px !important;
                }
              }
            }
          }
          .name {
            margin-top: 6px;
            margin-right: 120px;
            color: #222831;
            font-size: 20px;
            line-height: 28px;
          }
          .type {
            margin-top: 15px;
            margin-right: 96px;
            color: #989cb2;
            @media (max-width: 1200px) {
              margin-top: 0px;
            }
          }
          .place {
            margin-top: 6px;
            padding-right: 145px;
            color: #989cb2;
          }
          button {
            position: absolute;
            font-size: 12px;
            background-color: #3da3f8;
            color: #fff;
            border: none;
            padding: 0 23px;
            line-height: 33px;
            right: 20px;
            bottom: 0px;
            cursor: pointer;
            @media (max-width: 1200px) {
              display: none;
            }
          }
        }
        .description {
          margin-top: 50px;
          padding: 0 20px;
          font-size: 16px;
          @media (max-width: 1200px) {
            padding: 0 20px 20px;
            margin-top: 0px;
          }
          .title {
            margin-bottom: 19px;
            color: #222831;
            font-size: 16px;
            @media (max-width: 1200px) {
              margin-bottom: 10px;
            }
          }
          .part1 {
            .title{
              font-weight: bold;
            }
            .content1 {
              font-size: 14px;
              word-break: break-word;
            }
            .content2{
              font-size: 14px;
              word-break: break-word;
            }
          }
          .part2 {
            .title{
              font-weight: bold;
            }
            @media (max-width: 1200px) {
              border-bottom: 1px solid #eaeaea;
              margin-bottom: 20px;
            }
            .content2 {
              margin-bottom: 30px;
              @media (max-width: 1200px) {
                margin-bottom: 10px;
              }
              .item {
                p {
                  &:first-of-type {
                    font-size: 14px;
                    color: #989cb2;
                    font-weight: 400;
                    margin: 4px 0;
                    line-height: 18px;
                  }
                  &:last-of-type {
                    color: #000;
                    font-size: 14px;
                    line-height: 20px;
                    @media (max-width: 1200px) {
                      margin: 0 !important;
                    }
                  }
                }
              }
            }
          }
        }
        .apply {
          width: 100%;
          padding: 20px 0 100px;
          text-align: center;
          @media (max-width: 1200px) {
            display: none;
          }
          span {
            display: inline-block;
            padding: 0 30px;
            font-size: 14px;
            line-height: 36px;
            background-color: #3ba2f8;
            color: #fff;
            cursor: pointer;
          }
        }
      }
      .right {
        background-color: #f4f4f6;
        padding-right: 10px;
        @media (max-width: 1200px) {
          display: none;
        }
        .inner {
          background-color: #fff;
          .title {
            padding: 0 20px;
            color: #090a0b;
            font-size: 16px;
            line-height: 60px;
            height: 60px;
            span {
              &:first-of-type {
                color: #222831;
                font-size: 16px;
                float: left;
              }
              &:last-of-type {
                float: right;
                color: #9a9fac;
                font-size: 12px;
                line-height: 60px;
                cursor: pointer;
              }
            }
          }
          .common {
            text-align: left;
            padding: 16px 20px;
            border-bottom: 0.5px dashed #eee;
            color: #5c6170;
            font-size: 14px;
            line-height: 20px;
            cursor: pointer;
            &:last-of-type {
              border: none;
            }
          }
        }
      }
    }
  }
  .fixedButton{
    background-color: rgb(0, 153, 255);
    color: #fff;
    width: 80%;
    position: fixed;
    left: 50%;
    bottom: 20px;
    border: none;
    transform: translateX(-50%);
    display: none;
    @media (max-width: 1200px) {
      display: block;
    }
  }
}
</style>
<style lang="scss">
.recruitDetails{
  .el-input__inner{
    padding: 0 3px !important;
  }
  .footer{
    @media (max-width: 1200px) {
      display: none;
    }
  }
}
.el-message-box__wrapper{
    @media (max-width: 1200px) {
      .el-message-box{
        width: 90% !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/onlineApp/details.vue